export default "__VITE_ASSET__ZEUq1MB2__"